/* eslint-disable @typescript-eslint/no-explicit-any */
import { requestChangeStatusMemberRegister } from 'app/api/event'
import {
  IActionEvent,
  IEvent,
  StatusMemberRegisterWaiting,
} from 'app/api/event/model'
import { ITradeUnionMember } from 'app/api/tradeUnionMembers/model'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseCol } from 'app/components/common/BaseCol'
import { BasePopconfirm } from 'app/components/common/BasePopconfirm'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { convertColumnTable } from 'app/components/tables/BaseTableReport/hook'
import { FORMAT_DD_MM_YYYY_HH_MM } from 'app/constant'
import { EventStatusEnum } from 'app/containers/EventManagement/type'
import { notificationController } from 'app/controllers/notification-controller'
import { EventKeys } from 'app/react-query/query-key/event'
import { isEqual } from 'lodash'
import { DateUtil } from 'parkway-web-common'
import { useState } from 'react'
import { useQueryClient } from 'react-query'
import { ModalCheckIn } from '../ModalCheckIn'
import { RenderText } from 'app/containers/EventManagement/hook'

interface IData {
  key?: number
  activity?: IActionEvent
  reason?: string
  event?: IEvent
  id?: number

  approved_by?: ITradeUnionMember
}

export const ActionRegisteredByStatusLayout = ({
  data,
  isLoading,
  status,
}: {
  data: any[]
  isLoading: boolean
  status: StatusMemberRegisterWaiting
}) => {
  const query = useQueryClient()
  const [isLoadingCancel, setIsLoadingCancel] = useState(false)
  const onPressCancel = async (
    id?: number,
    statusOther?: StatusMemberRegisterWaiting,
  ) => {
    if (!id || !statusOther) return
    try {
      setIsLoadingCancel(true)

      const res = await requestChangeStatusMemberRegister({
        id,
        status: statusOther,
      })
      if (res) {
        query.invalidateQueries({
          queryKey: EventKeys.allListActionNotJoinByMember,
        })
        query.invalidateQueries({
          queryKey: EventKeys.allListActionRegisteredByMember,
        })

        notificationController.success({ message: 'Thành công' })
      }
    } catch (error) {
      console.log({ error })
    } finally {
      setIsLoadingCancel(false)
    }
  }

  return (
    <BaseSpace>
      <BaseTableManagement
        dataSource={data}
        columns={[
          convertColumnTable<IData>({
            title: 'STT',
            key: 'key',
            classNameWidthColumnOverwrite: 'number-column',
            fixed: 'left',
            render: value => {
              return (
                <BaseText children={value} fontWeight="medium" opacity="0.7" />
              )
            },
          }),
          convertColumnTable<IData>({
            title: 'Tên hoạt động',
            key: 'activity',
            classNameWidthColumnOverwrite: 'big-column',
            fixed: 'left',
            render: (_, record) => {
              return (
                <BaseText
                  children={record?.activity?.name}
                  fontWeight="semibold"
                  colorText={(() => {
                    switch (status) {
                      case StatusMemberRegisterWaiting.WAITING:
                        return 'otherBlueColor'
                      case StatusMemberRegisterWaiting.ACCEPTED:
                        return 'statesGreenColor'
                      case StatusMemberRegisterWaiting.REJECTED:
                        return 'statesRedColor'
                      default:
                        return 'primaryColor'
                    }
                  })()}
                />
              )
            },
          }),
          convertColumnTable<IData>({
            title: 'Sự kiện',
            key: 'event',
            classNameWidthColumnOverwrite: 'big-column',
            render: (_, record) => {
              return (
                <BaseSpace size={8}>
                  <BaseText
                    children={record?.activity?.event?.name_event}
                    fontWeight="medium"
                    opacity="0.7"
                  />
                  <BaseText
                    fontWeight="medium"
                    opacity="0.7"
                    children={
                      <RenderText
                        text={record?.activity?.event?.description ?? ''}
                      />
                    }
                  />
                </BaseSpace>
              )
            },
          }),
          
          convertColumnTable<IData>({
            title: 'Thời gian đăng ký',
            key: 'event',
            classNameWidthColumnOverwrite: 'big-column',
            render: (_, record) => {
              return (
                <BaseText
                  children={`${DateUtil.formatDate(
                    record?.activity?.event?.time_register_start ?? '',
                    FORMAT_DD_MM_YYYY_HH_MM,
                  )} - ${DateUtil.formatDate(
                    record?.activity?.event?.time_register_end ?? '',
                    FORMAT_DD_MM_YYYY_HH_MM,
                  )}`}
                  fontWeight="medium"
                  colorText="statesGreenColor"
                />
              )
            },
          }),
          convertColumnTable<IData>({
            title: 'Thời gian diễn ra sự kiện',
            key: 'event',
            classNameWidthColumnOverwrite: 'big-column',
            render: (_, record) => {
              return (
                <BaseText
                  children={`${DateUtil.formatDate(
                    record?.activity?.event?.time_start ?? '',
                    FORMAT_DD_MM_YYYY_HH_MM,
                  )} - ${DateUtil.formatDate(
                    record?.activity?.event?.time_end ?? '',
                    FORMAT_DD_MM_YYYY_HH_MM,
                  )}`}
                  fontWeight="medium"
                  opacity="0.7"
                />
              )
            },
          }),

          ...(isEqual(StatusMemberRegisterWaiting.ACCEPTED, status) ||
          isEqual(StatusMemberRegisterWaiting.REJECTED, status)
            ? [
                convertColumnTable<IData>({
                  title: isEqual(StatusMemberRegisterWaiting.ACCEPTED, status)
                    ? 'Người duyệt'
                    : 'Người từ chối',
                  key: 'approved_by',
                  classNameWidthColumnOverwrite: 'big-column',
                  render: (_, record) => {
                    if (!record?.approved_by) return null
                    return (
                      <BaseSpace size={4}>
                        <BaseText
                          children={record?.approved_by?.fullName}
                          fontWeight="semibold"
                        />
                        <BaseText
                          children={`Email: ${
                            record?.approved_by?.email ?? ''
                          }`}
                        />

                        <BaseText
                          children={`Mã quản lý: ${
                            record?.approved_by?.mql ?? ''
                          }`}
                        />
                      </BaseSpace>
                    )
                  },
                }),
              ]
            : []),

          ...(isEqual(status, StatusMemberRegisterWaiting.REJECTED)
            ? [
                convertColumnTable<IData>({
                  title: 'Lý do từ chối',
                  key: 'activity',
                  classNameWidthColumnOverwrite: 'big-column',
                  render: (_, record) => {
                    return (
                      <BaseText
                        children={record?.reason}
                        fontWeight="semibold"
                      />
                    )
                  },
                }),
              ]
            : [
                convertColumnTable<IData>({
                  title: '',
                  key: 'activity',
                  fixed: 'right',
                  render: (_, record) => {
                    return (
                      <BaseRow justify={'end'}>
                        <BaseCol>
                          {(() => {
                            switch (status) {
                              case StatusMemberRegisterWaiting.WAITING:
                                return (
                                  <BasePopconfirm
                                    onConfirm={() =>
                                      onPressCancel(
                                        record?.id,
                                        StatusMemberRegisterWaiting.CANCELED,
                                      )
                                    }
                                    title={'Bạn có chắc chắn muốn huỷ đăng ký?'}
                                  >
                                    <BaseButton
                                      loading={isLoadingCancel}
                                      children={'Huỷ đăng ký'}
                                    />
                                  </BasePopconfirm>
                                )
                              case StatusMemberRegisterWaiting.ACCEPTED:
                                switch (record?.activity?.event?.status) {
                                  case EventStatusEnum.REGISTRATION:
                                    return (
                                      <BasePopconfirm
                                        onConfirm={() =>
                                          onPressCancel(
                                            record?.id,
                                            StatusMemberRegisterWaiting.CANCELED,
                                          )
                                        }
                                        title={
                                          'Bạn có chắc chắn muốn huỷ đăng ký?'
                                        }
                                      >
                                        <BaseButton
                                          loading={isLoadingCancel}
                                          children={'Huỷ đăng ký'}
                                        />
                                      </BasePopconfirm>
                                    )
                                  case EventStatusEnum.IN_PROGRESS:
                                    return (
                                      <ModalCheckIn action={record?.activity} />
                                    )
                                }

                                break
                              case StatusMemberRegisterWaiting.CANCELED:
                                if (
                                  isEqual(
                                    record?.activity?.event?.status,
                                    EventStatusEnum.REGISTRATION,
                                  )
                                ) {
                                  return (
                                    <BasePopconfirm
                                      onConfirm={() =>
                                        onPressCancel(
                                          record?.id,
                                          StatusMemberRegisterWaiting.WAITING,
                                        )
                                      }
                                      title={
                                        'Bạn có chắc muốn khôi phục đăng ký?'
                                      }
                                    >
                                      <BaseButton
                                        loading={isLoadingCancel}
                                        children={'Khôi phục đăng ký'}
                                      />
                                    </BasePopconfirm>
                                  )
                                }
                                break
                            }
                          })()}
                        </BaseCol>
                      </BaseRow>
                    )
                  },
                }),
              ]),
        ]}
        loading={isLoading}
        scroll={{ x: true }}
      />
    </BaseSpace>
  )
}
